import axios from "axios";

export const getIsProd = () => {
  return window.location.hostname?.includes("mediakit.ilolas.com");
  // return true;
};

const currentDomain = window.location.hostname;
export const environment = getIsProd() ? "production" : currentDomain.includes("stats.ilolas.com") ? "staging" : "development";

const isProd = getIsProd();

// ==================== API Base URLs ====================
export const authAPI = isProd
  ? "https://prod-auth-api.ilolas.com/"
  : "https://authapi.ilolas.com/";

export const coreAPI = isProd
  ? "https://prod-base-api.ilolas.com/"
  : "https://coreapi.ilolas.com/";

export const wordpress_url = isProd
  ? "https://app.ilolas.com"
  : "https://staging.ilolas.com";

export const messagingAPI = isProd
  ? "https://messagingapi.ilolas.com/"
  : "https://messagingapi.ilolas.com/";

export const frontend_url = isProd
  ? 'https://mediakit.ilolas.com'
  : 'https://stats.ilolas.com';

// ==================== API Configuration ====================
const API_VERSION = 'api';
const GRAPH_API_VERSION = "v24.0";
const INSTAGRAM_CLIENT_ID = "619555224188577";

export const authDomain = `${authAPI}${API_VERSION}`;
export const coreDomain = `${coreAPI}${API_VERSION}`;
export const messagingDomain = `${messagingAPI}${API_VERSION}`;
export const BASE_GRAPH_API_URL = `https://graph.facebook.com/${GRAPH_API_VERSION}`;

// ==================== Sentry Configuration ====================
export const sentryOrgName = 'ilola'
export const sentryProjectName = 'ilola-frontend'
export const sentryDSN = "https://fd116f42afa3bd3b36feffb2db8c72f2@o4511954107039744.ingest.us.sentry.io/4511954112348160";
export const sentryAuthToken = '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';

// ==================== Helper Functions ====================
const buildUrlWithParams = (baseUrl, params = {}) => {
  const url = new URL(baseUrl);
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      url.searchParams.append(key, value);
    }
  });
  return url.toString();
};

// EndPoints
const endPoints = {
  /*********************** Auth End Points Start *************************/
  // SignUp User
  signUp: `${authDomain}/auth/sign-up`,

  // Login User
  login: `${authDomain}/Account/LoginUser`,

  // Login User WP
  loginWp: `${wordpress_url}/wp-json/jwt-sso/v1/validate`,

  // Logout User WP
  logoutWp: `${wordpress_url}/wp-json/jwt-sso/v1/logout`,

  // Forget Password (WordPress)
  forgetPassword: `${wordpress_url}/wp-json/ilola/v1/auth/forgot-password`,

  // Verify Otp (WordPress)
  verifyOtp: `${wordpress_url}/wp-json/ilola/v1/auth/verify-code`,

  // Reset Password (WordPress)
  resetPassword: `${wordpress_url}/wp-json/ilola/v1/auth/reset-password`,

  // Check User on React
  checkUserOnReact: `${authDomain}/Account/GetUserByEmail`,

  // Admin — paginated user list
  getAllUsersURL: `${authDomain}/Account/GetAllUsers`,

  // Check User on Wordpress
  checkUserOnWordpress: `${wordpress_url}/wp-json/custom/v1/check-email`,

  // Get Insta Data
  getInstaUnauthenticatedData: `${coreDomain}/Insta/GetInstagramDetailsUnauthenticatedUser/`,

  // Validate User for Wordpress
  validateUserForWordpress: `${coreDomain}/MediaKitWordPressIntegration/LoggedInWordPressUser`,

  // Create Media for Wordpress
  createMediaForWordpress: `${coreDomain}/GenerateMediaKit/GenerateMediaKitForUser`,

  // Update User Email
  updateUserEmail: `${coreDomain}/MediaKitWordPressIntegration/UpdateUserEmail`,

  // Register
  register: `${authDomain}/Account/Register`,

  // Save Instagram Data
  saveDataForMediaKit: `${coreDomain}/controlpanel/SaveOrUpdateMediaKitDetails`,

  // Save Links Data
  saveDataForSalesLinks: `${coreDomain}/MediaKit/SaveOrUpdateMediaKitSalesLink`,

  // Update Links (confirm + visibility toggle)
  updateLinks: `${coreDomain}/controlpanel/UpdateLinks`,

  // Auto Login
  autoLogin: `${authDomain}/Account/AutoLoginReact`,

  // Fetch Countries
  fetchCountries: `${coreAPI}GetCountry/`,

  // Fetch States
  fetchStates: `${coreDomain}/controlpanel/GetStateCountryWise`,

  // Fetch States
  fetchCities: `${coreDomain}/controlpanel/GetCityCountryWise`,

  // Update Profile Details
  updateProfileData: `${coreDomain}/ChargeBeePayments/SaveOrUpdateChargeBeeCustomerTransactionDetails`,

  updateProfilePhoto: `${coreDomain}/controlpanel/UpdateProfilePhoto`,

  // Get Profile Details
  getProfileData: `${coreDomain}/ChargeBeePayments/GetUserChargeBeeBillingDetails`,

  // User Plan
  userPlanTypeURL: `${coreDomain}/ChargeBeePayments/GetUserPaid`,

  // Get Instagram User Basic Details (for social channel addition)
  getInstagramUserBasicDetails: `${coreDomain}/Insta/GetInstagramUserBasicDetails`,

  // Get Instagram Data
  getInstaData: `${coreDomain}/Insta/GetInstaDetials/`,

  // Get Creator Insight (Instagram + TikTok)
  getCreatorInsight: `${coreDomain}/Insta/GetCreatorInsight`,

  // Set a Password
  setPassword: `${authDomain}/Account/CreatePassword`,

  /*********************** Auth End Points End *************************/

  /*********************** Dashboard End Points Start *************************/
  // Live Media Kit URL
  liveMediaKitURL: `${coreDomain}/MediaKitLive/GetMediaKitLiveLink`,

  // Media Kit Social URL
  mediaKitSocialURL: `${coreDomain}/MediaKitDashboard/SocialChannelAuthenticationStatus`,

  // Verify Social Media Existence
  verifySocialMediaExistenceURL: ({ mediaKitId, userId, socialChannelName }) =>
    `${coreDomain}/MediaKit/GetSocialChannlesByMediaKitId/${mediaKitId}?callingUserId=${userId}&socilChannelName=${socialChannelName}`,

  // Get Social Post From URL
  getSocialMediaPostURL: ({ socialChannel, postUrl, username }) =>
    buildUrlWithParams(`${coreDomain}/SocialChannel/GetSocialPostFromUrl`, {
      userName: username,
      socialChannel,
      url: postUrl,
    }),

  // Get Social Media Posts List (grid)
  getSocialMediaPostsURL: ({ channel, username, channelName, userName, nextCursor, previousCursor, limit }) =>
    buildUrlWithParams(`${coreDomain}/SocialChannel/GetSocialMediaPosts`, {
      UserName: username || userName,
      ChannelName: channel || channelName,
      ...(limit != null && { Limit: limit }),
      ...(nextCursor && { NextCursor: nextCursor }),
      ...(previousCursor && { PreviousCursor: previousCursor }),
    }),

  // Get Instagram Post Insight (tile selection)
  getInstagramPostInsightURL: ({ userId }) =>
    buildUrlWithParams(`${coreDomain}/SocialChannel/GetInstagramPostInsight`, {
      UserId: userId,
    }),

  // Get YouTube Video Insight (tile selection)
  getYoutubeVideoInsightURL: ({ videoId }) =>
    buildUrlWithParams(`${coreDomain}/SocialChannel/GetYoutubeVideoInsightsById`, {
      videoId,
    }),

  // Get TikTok Post Insight (tile selection)
  getTiktokPostInsightURL: `${coreDomain}/SocialChannel/GetTikTokPostInsights`,

  // Upload Image File
  uploadImage: `${coreDomain}/File/UploadImage`,

  // Upload Video File
  uploadVideo: `${coreDomain}/File/UploadVideo`,

  // Upload Image File
  getMediaKitDetails: `${coreDomain}/controlpanel/GetMediaKitDetails`,

  // Get Reviews
  saveOrUpdateCreateReviews: `${coreDomain}/MediaKit/SaveOrUpdateCreatorRequestReview`,

  // Cancel Subscription
  cancelSubscription: `${coreDomain}/MediaKitDashboard/CancelMediaKitSubscription`,

  // Renew Subscription
  renewSubscription: `${coreDomain}/MediaKitDashboard/RenewCancelledMediaKitSubscription`,

  // Remove Social Authentication
  removeSocialAuth: `${coreDomain}/MediaKitDashboard/RemoveSocialChannelAuthentication`,

  // Delete Media Kit
  deleteMediaKit: `${coreDomain}/MediaKitDashboard/DeleteMediaKit/`,

  // Renew Subscription
  sendMailToBrandURL: `${coreDomain}/Email/InviteBrandToSubmitReview`,

  // Authenticate TikTok
  authTikTok: `${coreDomain}/MediaKitTiktokAuthentication/TCMAuthenticateFlow`,

  // TikTok signup (unauthenticated registration flow)
  authenticateTikTokSignup: `${coreDomain}/MediaKitTiktokAuthentication/AuthenticatWithTikTok`,
  getTikTokUserDetailsSignup: `${coreDomain}/MediaKitTiktokAuthentication/GetTikTokUserDetails`,

  // Authenticate Instagram
  authInstagram: `${coreDomain}/InstagramAuthentication/callback`,

  // Get Instagram Me Data
  getInstagramMeData: `${coreDomain}/InstagramAuthentication/me`,

  // Theme Color Update
  themeColorUpdate: `${coreDomain}/controlpanel/UpdateThemeColor`,

  // Theme Font Update
  themeFontUpdate: `${coreDomain}/controlpanel/UpdateThemeFont`,

  // Theme Color Update
  checkInsta: `${authDomain}/Account/CheckInstagramDetailsForAuthentication`,

  // Login with Instagram
  loginWithInstagram: `${authDomain}/Account/LoginWithInstagram`,

  /*********************** Media Kit Authentication URLs *************************/
  tiktokURL: async ({ mediaKitId, userId }) => {
    try {
      const location = window.location.pathname;
      const { data } = await axios.post(
        `${coreDomain}/MediaKitTiktokAuthentication/TCMAuthenticateFlow`,
        {
          userId,
          mediaKitId,
          redirectURI: `${frontend_url}${location}`,
        }
      );

      if (data?.result?.authUrl) {
        window.open(data.result.authUrl, '_self');
      } else {
        throw new Error('No auth URL received from TikTok authentication');
      }
    } catch (error) {
      console.error('TikTok authentication error:', error);
      throw error;
    }
  },

  tiktokSignupURL: async ({ userId, email, tikTokHandle }) => {
    try {
      const { data } = await axios.post(
        `${coreDomain}/MediaKitTiktokAuthentication/AuthenticatWithTikTok`,
        {
          tikTokHandle,
          email,
          userId,
          redirectURI: `${frontend_url}/registration?platform=tiktok`,
        }
      );

      if (data?.result?.authUrl) {
        window.open(data.result.authUrl, '_self');
      } else {
        throw new Error('No auth URL received from TikTok authentication');
      }
    } catch (error) {
      console.error('TikTok signup authentication error:', error);
      throw error;
    }
  },

  instaURL: () => {
    const redirectUri = encodeURIComponent(`${frontend_url}/shareable-media-kit/kit-verified`);
    const scopes = [
      'instagram_business_basic',
      'instagram_business_manage_messages',
      'instagram_business_manage_comments',
      'instagram_business_content_publish',
      'instagram_business_manage_insights'
    ].join('%2C');

    return `https://www.instagram.com/oauth/authorize?force_reauth=true&client_id=${INSTAGRAM_CLIENT_ID}&redirect_uri=${redirectUri}&response_type=code&scope=${scopes}`;
  },

  /*********************** Collab Center URLs *************************/
  // Check Status For Gifted
  wordPressUserStatusURL: `${coreDomain}/MediaKitDashboard/GetWordPressUserStatus`,

  // Check Status for Paid
  creatorWaitlistStatusURL: `${coreDomain}/MediaKitDashboard/GetCreatorWaitListStatus`,

  // Check Status for JoinWaitList
  joinWaitlistURL: `${coreDomain}/MediaKitDashboard/CreatorJoinedWaitlist`,

  // Admin dashboard — payment A/B test statistics
  paymentABTestStatisticsURL: `${coreDomain}/MediaKitDashboard/GetPaymentABTestStatistics`,

  // Admin — delete user
  deleteUserURL: `${coreDomain}/MediaKitDashboard/DeleteUser`,

  // Admin — update user
  updateUserURL: `${coreDomain}/MediaKitDashboard/UpdateUser`,

  // Get Social Channel Details
  getSocialChannelDetails: `${coreDomain}/MediaKit/GetSocialChannlesByMediaKitId`,

  // Save Performance Fact
  savePerformanceFact: `${coreDomain}/MediaKit/SaveOrUpdatePerformanceFact`,

  // Get Performance Facts
  getPerformanceFact: `${coreDomain}/MediaKit/GetPerformanceFactsByMediaKitId`,

  // Get Custom Facts
  getCustomFacts: `${coreDomain}/MediaKit/GetCustomFactsByMediaKitId`,

  // Save Custom Facts
  saveCustomFacts: `${coreDomain}/MediaKit/SaveOrUpdateCustomFact`,

  // Get Social Channel Details
  getSocialChannel: `${coreDomain}/MediaKit/GetSocialChannel`,

  // Update Or Save Social Channels
  updateOrSaveSocialChannelsURL: `${coreDomain}/MediaKit/SaveOrUpdateSocialChannel`,

  // Update User Email
  updateUserDisplayEmail: `${coreDomain}/controlpanel/UpdateDisplayEmail`,

  // Update Profile Bio (bio + description visibility)
  updateProfileBio: `${coreDomain}/controlpanel/UpdateProfileBio`,

  // Update Profile Name (full name)
  updateProfileName: `${coreDomain}/controlpanel/UpdateProfileName`,

  // Update Age Range (age + visibility)
  updateAgeRange: `${coreDomain}/controlpanel/UpdateAgeRange`,

  // Update Location (country + city)
  updateLocation: `${coreDomain}/controlpanel/UpdateLocation`,

  // VerifyYoutube Channel
  verifyYoutubeChannelURL: `${coreDomain}/Youtube/VerifyYoutubeChannel`,

  // VerifyPinterest Channel
  verifyPinterestChannelURL: `${coreDomain}/Pinterest/VerifyPinterestUser`,

  // Delete Social Channel
  deleteSocialChannel: `${coreDomain}/MediaKit/DeleteSocialChannelAndData`,

  chargebeePayments: `${coreDomain}/ChargeBeePayments/Payment`,

  // Get ChargeBee hosted page URL to update the customer's payment method
  updatePaymentMethodType: `${coreDomain}/ChargeBeePayments/UpdatePaymentMethodType`,

  // Get the customer's current ChargeBee payment method(s)
  getCustomerPaymentMethod: `${coreDomain}/ChargeBeePayments/GetCustomerPaymentMethod`,

  // Get Quaderno Tax Amount (only base URL with parameter placeholders)
  getQuadernoTaxAmount: `${coreDomain}/ChargeBeePayments/GetQuadernoTaxAmount?country=`,

  // Get Social Channel URL
  getSocialChannelPostURL: `${coreDomain}/SocialChannel/GetSocialPostFromUrl`,

  // Update Favourite Facts (confirm + visibility toggle)
  updateFavFacts: `${coreDomain}/controlpanel/UpdateFavFacts`,

  // Update Top Interests (confirm + visibility toggle)
  updateTopInterest: `${coreDomain}/controlpanel/UpdateTopInterest`,

  // Update Deliverables / Offerings (confirm + visibility toggle)
  updateDeliverables: `${coreDomain}/controlpanel/UpdateDeliverables`,

  // Update Rates (confirm + visibility toggle)
  updateRates: `${coreDomain}/controlpanel/UpdateRates`,

  // Update Top Videos / Favourite Content (confirm + visibility toggle)
  updateFavouriteContent: `${coreDomain}/controlpanel/UpdateFavouriteContent`,

  // Save Top Content Videos
  saveTopContentVideos: `${coreDomain}/MediaKit/SaveOrUpdateMediaKitFavouriteContent`,

  // Send Custom Deliverable
  sendCustomDeliverable: `${coreDomain}/MediaKit/PostPutMediaKitDeliverables`,

  // Send All Deliverables
  sendAllDeliverables: `${coreDomain}/MediaKit/SaveOrUpdateMediaKitDeliverables`,

  // Get Custom Rates
  getCustomSocialRates: `${coreDomain}/MediaKit/GetMediaKitUserRates`,

  // Send Custom Rates
  sendCustomSocialRates: `${coreDomain}/MediaKit/SaveOrUpdateMediaKitUserRate`,

  // Send All Rates
  sendAllRates: `${coreDomain}/MediaKit/SaveOrUpdateMediaKitRates`,

  // Save Collaboration Banner
  saveCollaborationBanner: `${coreDomain}/MediaKit/SaveOrUpdateCollaborationBanner`,

  // Update Brand Partners (confirm + visibility toggle)
  updateBrandPartner: `${coreDomain}/controlpanel/UpdateBrandPartner`,

  // Media kit reviews
  getMediaKitReviews: `${coreDomain}/MediaKit/GetMediaKitReview`,

  // Update Top Posts
  updateTopPost: `${coreDomain}/MediaKit/SaveOrUpdateMediaKitTopPost`,

  // Toggle Top Posts section visibility
  toggleTopPostSection: `${coreDomain}/controlpanel/ToggleTopPostSection`,

  // Toggle Verification Banner section visibility
  toggleBannerSection: `${coreDomain}/controlpanel/ToggleBannerSection`,

  // Toggle Audience section visibility
  toggleAudienceSection: `${coreDomain}/controlpanel/ToggleAudienceSection`,

  // Toggle Review section visibility
  toggleReviewSection: `${coreDomain}/controlpanel/ToggleReviewSection`,

  // Save Media Kit Live
  saveMediaKitLive: `${coreDomain}/MediaKitLive/SaveOrUpdateMediaKitLive`,

  // Delete Top Posts
  deleteTopPost: `${coreDomain}/MediaKit/DeleteMediaKitTopPost`,

  // Email Verification
  verifyEmail: `${authDomain}/Account/SendConfirmationEmail`,

  // Email Confirmation
  emailConfirmation: `${authDomain}/Account/ConfirmEmail`,

  // Is Email Verified
  isEmailVerified: `${authDomain}/Account/IsEmailVerified`,

  // Collab Rating Endpoints
  sendMailToBrand: `${coreDomain}/Email/InviteBrandToSubmitReview`,

  // Send OTP Mail To Brand For Submit Review
  sendOtpMail: `${authDomain}/Account/SendOtpToBrandForSubmitReview`,

  // Verify OTP Mail For Submit Review
  verifyOTPMail: `${authDomain}/Account/VerifyOTP`,

  // Submit Media Kit Review
  submitMediaKitReview: `${coreDomain}/MediaKit/SaveOrUpdateMediaKitReview`,

  // Trigger Mail
  triggerMail: `${messagingDomain}/EmailCenter/TriggerEmails`,

  // Get Creator Details By Request Review By Id
  getCreatorDetailsApi: `${coreDomain}/MediaKit/GetCreatorDetailsByRequestReviewById`,

  // Get Creator Request Review By Id
  getCreatorRequestReviewById: `${coreDomain}/MediaKit/GetRequestReviewById`,

  // Get Instagram Favourite Content
  getInstaFavoriteContent: `${coreDomain}/Insta/GetInstagramFavouriteContent`,

  // Get Live Media Kit Data
  getLiveMediaKitDetails: `${coreDomain}/MediaKitLive/GetMediaKitLive`,

  // Get Live Media Kit Data
  // convertDummyMKToReal: `${coreDomain}/GenerateMediaKit/ConvertDummyMediaKitToReal`,
  convertDummyMKToReal: `${coreDomain}/GenerateMediaKit/ConvertSampleMediaKitToReal`,

  // Get overall rating
  getOverallRating: `${coreDomain}/MediaKit/GetMediaKitReviewRating`,

  // Post User Activity Event (analytics tracking, shown per-user in admin panel)
  postUserEvent: `${coreDomain}/MediaKit/PostUserEvents`,

  // Get User Activity Events (admin panel — per-user activity feed)
  getUserEvents: `${coreDomain}/MediaKit/GetUserEvents`,
};

export default endPoints;
